<script lang="ts">
import SettingsBox from '../../elements/SettingsBox.svelte';
import Title from "../../elements/settings/Title.svelte";
import TitleIcon from "../../elements/settings/TitleIcon.svelte";
import PrimaryBox from "../../elements/settings/PrimaryBox.svelte";
import Action from '../../elements/settings/Buttons/Action.svelte';
import { RemindersDB } from '../../../handlers/RemindersDB';
import { PinnedDB } from '../../../handlers/PinnedDB';

    async function clearData() {
        if (confirm('确定要清除所有数据吗？')) {
            [RemindersDB, PinnedDB].forEach(async idb => { 
                if (idb.db) await idb.removeAll();
            });

            localStorage.clear();
            sessionStorage.clear();
            window.location.reload();
        }
    }
</script>

<div class="border rounded-xl m-2 border-red-400 pt-1">
    <SettingsBox bordered={false} collapsable={false} id="danger-zone">
        <Title title="危险区域">
            <TitleIcon>
                <i class="lnr lnr-trash text-red-600 settings-title-icon"></i>
            </TitleIcon>
        </Title>    
        <PrimaryBox 
            label={{text: '清除数据'}} 
            description={{text:'清除所有数据，包括提醒、固定消息、Spotify 凭据和设置。此操作无法撤销。', iconClass: 'lnr lnr-question-circle'}}
            available={true}
        >
            <Action label="删除" custom customClass="text-primary bg-red-600 border-2 border-red-600" on:click={() => clearData()}/>
        </PrimaryBox>
    </SettingsBox>
</div>